module.exports = __webpack_public_path__ + "img/上下翻转-角标2.399472ff.svg";